const error = {
  userLimitReached: "사용자 제한에 도달했습니다.",
};

export { error };
